var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2H8.5C9.05 2 9.5 1.55 9.5 1C9.5 0.45 9.05 0 8.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16C0.5 17.1 1.4 18 2.5 18H8.5C9.05 18 9.5 17.55 9.5 17C9.5 16.45 9.05 16 8.5 16H2.5V2Z",
    fill: "#017BCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.15 8.64954L15.36 5.85954C15.04 5.53954 14.5 5.75954 14.5 6.20954V7.99954H7.5C6.95 7.99954 6.5 8.44954 6.5 8.99954C6.5 9.54954 6.95 9.99954 7.5 9.99954H14.5V11.7895C14.5 12.2395 15.04 12.4595 15.35 12.1395L18.14 9.34954C18.34 9.15954 18.34 8.83954 18.15 8.64954Z",
    fill: "#017BCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.f78d92d893ee8fa7dcce5e8be7341ef2.svg";
export { ForwardRef as ReactComponent };